module.exports = __webpack_public_path__ + "static/media/idear2.00cb1559.png";